import React, { Component } from 'react';
import './LoginSide.css';
import img from './../../images/Dani.svg';
import { Link } from 'react-router-dom';

export default class LoginSide extends Component {
    render() {
        return (

            <div 
                className="col-sm-10 col-md-10 col-lg-2 login-side d-flex flex-column justify-content-center align-items-center login-side-width">
                            <Link to={'/find-enterprise'} className="text-center">
                            {/* text-align: center; */}
                <img style={{height:'66px',width:'91px',marginBottom:'15px',marginTop: '15px'}} src={img}/>
                <div className="align-items-center text-center text-lighter margin-bottom-none" 
                style={{color:'#1679C4',fontWeight: 'bold',width:'100%'}}>
                    {/* Want to <a href="https://www.ouroffice.io/engage-now/" target="_blank" rel="noopener noreferrer" className="login-fake-link">sign up</a> with OurOffice? */}
                
                
                    Want to  
                    
											<span className="login-fake-link">
												&nbsp;sign up&nbsp;
											</span>
										
                     with OurOffice
                </div>
                </Link>

            </div>
        );
    }
}